import 'construct-style-sheets-polyfill'; const styleSheet = new CSSStyleSheet(); styleSheet.replaceSync(`.dropdown-item {
    display: block;
    padding: var(--inv-dropdown-item-padding-y, 0.25em) var(--inv-dropdown-item-padding-x, 1em);
    clear: both;
    font-weight: 400;
    color: var(--inv-dropdown-link-color, #212529);
    text-align: inherit;
    text-decoration: none;
    white-space: nowrap;
    background-color: transparent;
    border: 0;
}

.dropdown-item:hover,
.dropdown-item:focus {
    color: var(--inv-dropdown-link-hover-color, #1e2125);
    background-color: var(--inv-dropdown-link-hover-background, #e9ecef);
}

.dropdown-item.active,
.dropdown-item:active {
    color: var(--inv-dropdown-link-active-color, #fff);
    text-decoration: none;
    background-color: var(--inv-dropdown-link-active-background, #0d6efd);
}

.dropdown-item.disabled,
.dropdown-item:disabled {
    color: var(--inv-dropdown-link-disabled-color, #adb5bd);
    pointer-events: none;
    background-color: transparent;
}
`); export default styleSheet;